import { z } from 'zod';
/** Opaque identifiers. UUID v7 in the database; treated as strings at the boundary. */
export const Id = z.string().uuid();
/**
 * Confidence score, 0–100 inclusive.
 * FR-05 requires a confidence score on type classification; NFR-06 requires it to
 * always be displayed for transparency. Integer so the UI never renders 87.3333.
 */
export const Confidence = z.number().int().min(0).max(100);
/**
 * Money in whole rupiah.
 *
 * IDR has no circulating sub-unit, and FR-10's formats (20K, 20rb, 1,2jt) all
 * resolve to whole rupiah. Stored as an integer to keep price-index aggregation
 * exact — never a float.
 */
export const Rupiah = z.number().int().nonnegative();
/** WGS-84 coordinate as read from the Geolocation API (NFR-04). */
export const GeoPoint = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    /** Device-reported accuracy in metres; used to qualify FR-16 signal 1. */
    accuracyM: z.number().nonnegative().nullable(),
});
/**
 * Normalised bounding box within the source image, origin top-left, values 0–1.
 *
 * This is the `image region reference` that TAD 4.5 requires on every correction
 * so the corrections table is usable as a training dataset (TAD 4.4.3).
 */
export const BoundingBox = z.object({
    x: z.number().min(0).max(1),
    y: z.number().min(0).max(1),
    w: z.number().min(0).max(1),
    h: z.number().min(0).max(1),
});
/** ISO-8601 instant, always UTC at the boundary. Display converts to WIB. */
export const Timestamp = z.string().datetime();
/**
 * Client-generated idempotency key.
 * FR-07 submit and FR-08 check-out enforce this so mobile retries on poor
 * networks cannot create duplicate visits (TAD 4.5).
 */
export const IdempotencyKey = z.string().min(16).max(128);
//# sourceMappingURL=primitives.js.map